module.exports = __webpack_public_path__ + "img/prompt.b95076e8.svg";